import { render, staticRenderFns } from "./TrisTable.vue?vue&type=template&id=f1773472"
import script from "./TrisTable.vue?vue&type=script&lang=ts"
export * from "./TrisTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports